import React, { useEffect } from 'react';
import { useCustomers } from './CustomersStore';
import { MainTable } from '../../Components/MainTable/MainTable';
import Add from './Add';
import Edit from './Edit';
import { useState } from 'react';
import { Modal } from 'antd';
import Transactions from '../Transactions/Transactions';
import { useTransaction } from '../Transactions/TransactionStore';

function Customers() {
    const [open, setOpen] = useState(false);
    const { customers, columns, fetchCustomers, deleteCustomer, setEd, setCustomer } = useCustomers();
    const { getKontrTr } = useTransaction();
    useEffect(() => {
        fetchCustomers();
    }, []);
    return (
        <>
        <Modal
            title="Kontragent"
            open={open}
            onOk={() => setOpen(false)}
            onCancel={() => setOpen(false)}
            width={1500}
            footer={null}
        >
            <Transactions />
        </Modal>
            <MainTable 
                pageTitle={'Mijozlar'}
                pdata={customers}
                pcolumns={columns}
                defkey={'id'}
                add={<Add />}
                xwidth={1000}
                edw={1000}
                adw={1000}
                edit={<Edit />}
                onDelete={deleteCustomer}
                onEdit={(rec) => setEd(rec)}
                setEd={setEd}
                viewBtn={true}
                onView={(e, rec) => {
                    setCustomer(rec);
                    setOpen(true);
                    getKontrTr(rec.id);
                }}
            />
        </>
    );
}

export default Customers;
